import { Route, Routes } from "react-router-dom";
import Account from "./pages/account";

export function CustomerAccountTeamManagementRoutes() {
	return (
		<Routes>
			<Route index element={<Account />} />
		</Routes>
	);
}
